import { Resource } from 'i18next'
import { set } from 'lodash'
import getService from '../base'
import apiKey from '../base/apiKey'
import { SheetModel } from './model'

//spreadsheetID is from googlespreadsheet url
//authKey is setting in google cloud platform by DEVop account devops@cloud-interactive.com

const spreadSheetInfo = {
  spreadsheetID: '1tWGM0EgC3GOl-ogasNBtkffe5k3n3SmBB6__LGereaA',
  spreadsheetIndex: 'web',
  authKey: 'AIzaSyCvtUM9cJcbVoIZ7RBI-sG2--BuR6Ipb-o',
  languages: ['zh-TW', 'en'],
}

export function googleSpreadsheetToJson(): Promise<Resource> {
  const { spreadsheetID, spreadsheetIndex, languages, authKey } = spreadSheetInfo
  const url = `https://sheets.googleapis.com/v4/spreadsheets/${spreadsheetID}/values/${spreadsheetIndex}?key=${authKey}`

  return getService<SheetModel>({
    config: { url, method: 'get' },
    name: apiKey.googleSpreadSheet,
    withAccessToken: false,
  })
    .then((response) => {
      return languages.reduce(
        (accumulator, currentLang) => {
          const langObject = response.data.values.slice(1)?.reduce((newAccumulator, [path, , value_zhTW, value_en]) => {
            if (path === 'TBD' || path === '') {
              // 如果 key 為 'TBD' 時不處理，返回原物件
              return newAccumulator
            } else {
              // 將值寫入物件巢狀結構
              return set(newAccumulator, path, currentLang === 'zh-TW' ? value_zhTW : value_en)
            }
          }, {})
          return {
            ...accumulator, // 保留先前物件內容
            [currentLang]: {
              translation: langObject,
            }, // 將該語言資料指派
          }
        },
        { en: { translation: {} }, 'zh-TW': { translation: {} } },
      )
    })
    .catch((error) => {
      throw new Error(`Spreadsheet to JSON 錯誤訊息為: ${error.message}`)
    })
}
